/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { useSelector } from "react-redux";

import objectPath from "object-path";

import * as builder from "_metronic/ducks/builder";
import { ReactComponent as SortNum1Icon } from "_metronic/layout/assets/layout-svg-icons/SortNum1.svg";
import { LayoutContextConsumer } from "_metronic/layout/LayoutContext";
import QuickActions from "_metronic/layout/sub-header/components/QuickActions";
// import BreadCrumbs from '_metronic/layout/sub-header/components/BreadCrumbs';

const SubHeader = () => {
  // Redux selectors using useSelector hook
  const subheaderMobileToggle = useSelector((store) =>
    objectPath.get(store.builder.layoutConfig, "subheader.mobile-toggle")
  );
  const subheaderCssClasses = useSelector((store) =>
    builder.selectors.getClasses(store, {
      path: "subheader",
      toString: true,
    })
  );
  const subheaderContainerCssClasses = useSelector((store) =>
    builder.selectors.getClasses(store, {
      path: "subheader_container",
      toString: true,
    })
  );

  return (
    <div id="kt_subheader" className={`kt-subheader ${subheaderCssClasses} kt-grid__item`}>
      <div className={`kt-container ${subheaderContainerCssClasses}`}>
        <div className="kt-subheader__main">
          {subheaderMobileToggle && (
            <button
              className="kt-subheader__mobile-toggle kt-subheader__mobile-toggle--left"
              id="kt_subheader_mobile_toggle"
            >
              <span />
            </button>
          )}

          <LayoutContextConsumer>
            {/*{({ subheader: { title, breadcrumb } }) => (*/}

            {({ subheader: { title } }) => (
              <>
                <h3 className="kt-subheader__title">{title}</h3>
                {/*<BreadCrumbs items={breadcrumb} />*/}
              </>
            )}
          </LayoutContextConsumer>

          <span className="kt-subheader__separator kt-subheader__separator--v" />
          <span className="kt-subheader__desc">#XRS-45670</span>
          <a href="#" className="btn btn-label-warning btn-bold btn-sm btn-icon-h kt-margin-l-10">
            Add New
          </a>
        </div>

        <div className="kt-subheader__toolbar">
          <div className="kt-subheader__wrapper">
            <button type="button" className="btn kt-subheader__btn-primary">
              Actions &nbsp;
              <SortNum1Icon className="kt-svg-icon kt-svg-icon--sm" />
            </button>
            <QuickActions />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
